// Colori per le voci configurabili dello Scadenziario (Priorità, Stato, Visibilità).
// Dalla versione con selettore libero il colore è salvato come codice HEX (es. "#2563eb").
// Per retro-compatibilità supportiamo ancora le vecchie chiavi tavolozza (es. "blue").
export const ADL_PALETTE = [
  { key: "slate", label: "Grigio", hex: "#64748b" },
  { key: "zinc", label: "Neutro", hex: "#71717a" },
  { key: "blue", label: "Blu", hex: "#2563eb" },
  { key: "indigo", label: "Indaco", hex: "#4f46e5" },
  { key: "violet", label: "Viola", hex: "#7c3aed" },
  { key: "sky", label: "Azzurro", hex: "#0ea5e9" },
  { key: "teal", label: "Verde acqua", hex: "#14b8a6" },
  { key: "green", label: "Verde", hex: "#22c55e" },
  { key: "amber", label: "Ambra", hex: "#f59e0b" },
  { key: "yellow", label: "Giallo", hex: "#eab308" },
  { key: "orange", label: "Arancio", hex: "#f97316" },
  { key: "rose", label: "Rosa", hex: "#f43f5e" },
  { key: "red", label: "Rosso", hex: "#dc2626" },
];

const KEY_HEX = Object.fromEntries(ADL_PALETTE.map((p) => [p.key, p.hex]));

// Restituisce sempre un codice HEX da un valore che può essere HEX o una vecchia chiave tavolozza.
export const toHex = (v) => {
  if (typeof v === "string" && v.startsWith("#")) return v;
  return KEY_HEX[v] || "#64748b";
};

// Stile badge "outline" con tinta tenue, coerente con gli stati Interventi.
export const badgeStyle = (v) => {
  const hex = toHex(v);
  return { backgroundColor: `${hex}1a`, color: hex, borderColor: `${hex}55` };
};
